import { useRef, useState } from "react";
import PersonalDetailsScreen from "./components/PersonalDetailsScreen";
import OTPValidationScreen from "./components/OTPValidationScreen";
import PasswordInputScreen from "./components/PasswordInputScreen";
import api_requests from "../../resources/api_requests";
import {
  useLoggedInGuard,
  useLoginSuccess,
  useOnBusinessSelect,
} from "../../hooks/auth";
import Link from "../../modules/Link";
import Spinner from "../../modules/Spinner";
import { useTranslation } from "react-i18next";
import utils from "../../resources/utils";
import constant from "../../resources/constant";

const PERSONAL_DETAILS_SCREEN = "PERSONAL_DETAILS_SCREEN";
const OTP_VALIDATION_SCREEN = "OTP_VALIDATION_SCREEN";
const PASSWORD_INPUT_SCREEN = "PASSWORD_INPUT_SCREEN";


const SignUp = () => {
  const { loginSuccess } = useLoginSuccess();
  const { onBusinessSelect } = useOnBusinessSelect();
  const selectedCountry = utils._retrieveData(constant.SELECTED_COUNTRY);

  useLoggedInGuard();

  const SCREENS = {
  [PERSONAL_DETAILS_SCREEN]: (onNext) => (
    <PersonalDetailsScreen
      selectedCountry={selectedCountry}
      onNext={(data) => onNext(data, PERSONAL_DETAILS_SCREEN)}
    />
  ),
  [OTP_VALIDATION_SCREEN]: (onNext, formData) => (
    <OTPValidationScreen
      selectedCountry={selectedCountry}
      onNext={(data) => onNext(data, OTP_VALIDATION_SCREEN)}
      {...formData}
    />
  ),
  [PASSWORD_INPUT_SCREEN]: (onNext, _, isLoading) => (
    <PasswordInputScreen
      selectedCountry={selectedCountry}
      onNext={(data) => onNext(data, PASSWORD_INPUT_SCREEN)}
      isLoading={isLoading}
    />
  ),
};

  const [isLoading, setLoading] = useState(false);
  const [__screen, goTo] = useState(PERSONAL_DETAILS_SCREEN);
  const formDataRef = useRef();
  const otpValidationResponseRef = useRef();

  function handleRegister(password) {
    setLoading(true);
    const { firstName, lastName, businessName, email, contact } =
      formDataRef.current;
    const data = {
      first_name: firstName,
      last_name: lastName,
      above18_fair_use: true,
      password,
      country_of_registration: selectedCountry === 'india' ? 'IN' : 'ID',
    };

    if (selectedCountry === 'india') {
      data.email = email.toLowerCase().trim();
    } else {
      data.mobile = contact;
    }

    api_requests
      .update_profile(data, otpValidationResponseRef.current.access_token)
      .then((res1) => {
        console.log("from sign up success", res1);

        api_requests
          .register_business_enquiry(
            otpValidationResponseRef.current.access_token,
            {
              brand_name: businessName,
              business_type: "other",
              order_range: "1-5",
              business_email: email,
            },
          )
          .then(async (businessInfo) => {
            // create a data structure which is similar to
            // how login callback expects
            // for letting the user successfully enter the app
            const business = {
              brand_name: businessInfo?.data?.brand_name,
              business_id: businessInfo?.data?.business_id,
              business_name: businessInfo?.data?.business_name,
              parent_id: null,
              type_of_owner: businessInfo?.data?.owner_type,
            };

            loginSuccess({
              data: {
                token: otpValidationResponseRef.current.access_token,
                info: {
                  first_name: firstName,
                  last_name: lastName,
                  meta_info: {
                    email: email.toLowerCase().trim(),
                  },
                  mobile: contact,
                  business_info: [business],
                },
              },
            });

            await onBusinessSelect(business);
            setLoading(false);
          });
      })
      .catch((error) => {
          console.error("Signup flow failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onNext(options, screenFrom) {
    if (screenFrom === PERSONAL_DETAILS_SCREEN) {
      formDataRef.current = options;
      goTo(OTP_VALIDATION_SCREEN);
    } else if (screenFrom === OTP_VALIDATION_SCREEN) {
      otpValidationResponseRef.current = options;
      goTo(PASSWORD_INPUT_SCREEN);
    } else if (screenFrom === PASSWORD_INPUT_SCREEN) {
      handleRegister(options);
    }
  }

  const screenCb = SCREENS[__screen];

  const { t } = useTranslation();

  return (
    <div>
      {/* <DashboardContentLoaders /> */}
      {screenCb(onNext, formDataRef.current, isLoading)}
      <div className="flex items-center mt-[20px] justify-center text-stone-900 text-xs font-semibold font-custom">
        <div className="mr-[4px]">{t("already_have_account")}</div>
        <Link to="/login">{t("login")}</Link>
      </div>

      {/** Prelaoding the Spinner */}
      <Spinner hidden />
    </div>
  );
};

export default SignUp;
